/**
 * Ink strip above the page. It scrolls away with the content and gives the
 * paper shell below it a dark edge to sit against.
 */
export function AnnounceBar() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-ink px-5 py-[18px] text-center text-[14px] leading-[1.4] text-paper">
      <span className="text-[rgba(253,253,252,0.72)]">
        The Briefcase AI managed platform is available through private access.
      </span>
      <a
        href="/contact"
        data-analytics="click"
        data-cta="announce-demo"
        className="font-semibold text-paper underline underline-offset-[3px]"
      >
        Book a demo →
      </a>
    </div>
  );
}
